module.exports = __webpack_public_path__ + "img/info.4b62796c.png";